"use client";
import React, { useCallback, useMemo, useState } from "react";
import { Box, Grid, IconButton, Slide, Typography } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import Dialog from "@mui/material/Dialog";
import CloseIcon from "@mui/icons-material/Close";
import Link from "next/link";
import Image from "next/image";
import { TransitionProps } from "@mui/material/transitions";
import { usePathname } from "next/navigation";
import { Loader } from "../MainLoader/Loader";
import { AddToCartService, Cart, MainCart } from "@/app/services/cart";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="down" ref={ref} {...props} />;
});

interface MenuSubCategoryProps {
  subcategories: any;
  categorySlug: any;
  cid: any;
}

export const MenuSubCategory: React.FC<MenuSubCategoryProps> = ({
  subcategories,
  categorySlug,
  cid,
}) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [cart, setCart] = React.useState<Cart | null>(null);
  const addToCartService = useMemo(() => new AddToCartService(), []);
  const pathName = usePathname();
  const segments = pathName.split("/");
  const lastSegment = segments.pop() || "";

  const handleLoader = () => {
    setLoading(true);
  };
  const blankFunction = () => {};

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const getInitializeCart = useCallback(() => {
    const mainCart = addToCartService.getCart();
    if (!mainCart) {
      return;
    }
    const cartCidValid = mainCart?.cartItemRequestsById.find(
      (item: any) => item.cid === cid
    );
    if (cartCidValid) {
      setCart(cartCidValid);
    } else {
      console.log(`No cart found for CID: ${cid}`);
    }
  }, [addToCartService, cid]);

  React.useEffect(() => {
    getInitializeCart();
  }, [getInitializeCart]);

  return (
    <React.Fragment>
      {loading && <Loader />}
      <Box
        onClick={handleClickOpen}
        sx={{
          position: "fixed",
          bottom: {
            xs: 80,
            sm:
              cart?.cartItemRequests?.length == 0 || cart == null || undefined
                ? 20
                : 115,
          },
          right: 20,
          background: "#15741a",
          width: "auto",
          height: "auto",
          zIndex: 1000,
          borderRadius: "2rem",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          boxShadow: "1px 1px 4px 1px rgba(0, 0, 0, 0.2)",
          cursor: "pointer",
          padding: "0.5rem 12px",
        }}
      >
        <MenuIcon
          sx={{
            color: "white",
            fontSize: "25px",
          }}
        />
        &nbsp;
        <Typography variant="body1" sx={{ color: "white" }}>
          Menu
        </Typography>
      </Box>
      <Dialog
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
        keepMounted
        PaperProps={{
          sx: {
            position: "fixed",
            bottom: { xs: "100px", sm: "140px" },
            right: 0,
            width: "20rem",
            maxHeight: "25rem",
            minHeight: "25rem",
            padding: "8px 12px",
            "&:: -webkit-scrollbar": {
              display: "none",
            },
          },
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Box sx={{ width: "100%", textAlign: "right" }}>
          <IconButton
            onClick={handleClose}
            sx={{
              background: "white",
              "&:hover": {
                background: "#f2efefcf",
              },
            }}
          >
            <CloseIcon sx={{ cursor: "pointer", color: "black" }} />
          </IconButton>
        </Box>
        <Grid container xs={12} sm={12} md={12} lg={12}>
          {subcategories?.map((item: any, index: number) => (
            <Grid
              key={"subcategoryItem" + item?.id}
              container
              item
              xs={4}
              sm={4}
              md={4}
              lg={4}
              onClick={
                lastSegment !== item.slug.trim().replace(/\s+/g, "%20")
                  ? handleLoader
                  : blankFunction
              }
            >
              <Link
                prefetch={false}
                style={{
                  textDecoration: "none",
                  color: "inherit",
                  display: "grid",
                  margin: "0.5rem auto",
                  textAlign: "center",
                }}
                href={
                  categorySlug == undefined || categorySlug == ""
                    ? item.slug
                    : categorySlug + "/" + item.slug
                }
              >
                <Image
                  width={500}
                  height={500}
                  alt={item?.name}
                  src={item?.mobileImage?.secureHttpPath}
                  style={{
                    borderRadius: "100%",
                    objectFit: "cover",
                    height: "45px",
                    width: "45px",
                    margin: "auto",
                  }}
                />
                <Typography
                  variant="caption"
                  sx={{
                    margin: "auto",
                    fontWeight: "bold",
                    fontSize: "10px",
                    marginTop: "8px",
                  }}
                >
                  {item?.name}
                </Typography>
              </Link>
            </Grid>
          ))}
        </Grid>
      </Dialog>
    </React.Fragment>
  );
};
